module.exports = __webpack_public_path__ + "static/media/hoppinger-logo.16a84412.svg";